<template>
  <div class="catcheck">
    <cube-page type="catcheck-view" title="优惠券">
      <div slot="content" class="content-order">
        <div class="content-main">
          <div class="van-coupon-list__list">
            <div class="van-coupon" v-for="(item,index) in coupons" :key="index">
              <div class="van-coupon__content">
                <div class="van-coupon__head">
                  <h2 class="van-coupon__amount">{{item.value}}<span>元</span></h2>
                  <p class="van-coupon__condition">{{item.condition_text}}</p>
                </div>
                <div class="van-coupon__body">
                  <p class="van-coupon__name">{{item.title}}</p>
                  <p class="van-coupon__valid">{{item.expire_time}}</p>
                  <div role="checkbox" class="van-checkbox van-coupon__corner">
                    <van-button class="coupons-btn" type="danger" size="small" @click="onChange(index)">点击领取
                    </van-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <van-overlay :show="showNumber" @click="showNumber = false">
          <div class="wrapper" @click.stop>
            <div class="block">
              <h3>输入领取数量</h3>
              <van-cell-group>
                <van-field v-model="number" type="digit" label="数量" placeholder="请输入领取数量" />
              </van-cell-group>
<!--              <div class="message" v-if="maxlength > 0">Mxa：{{maxlength}}</div>-->
              <div class="footer">
                <van-button type="primary" size="small" @click="getCoupon" :loading="disabled">确定</van-button>
                <van-button type="default" size="small" @click="showNumber = false">取消</van-button>
              </div>
            </div>
          </div>
        </van-overlay>
      </div>
    </cube-page>
  </div>
</template>
<script>
  import CubePage from "../TP/cube-page.vue";
  import * as util from "@/utils/network";

  export default {
    components: {
      CubePage,
    },
    data() {
      return {
        chosenCoupon: -1,
        coupons: [],
        role: '20', // 10个人 20 分销商
        showNumber: false,
        number: 1,
        maxlength: 1, // 最大领取数 为点击的对象下的number
        disabled: false,
      }
    },
    mounted() {
      this.getCardTypeList();
    },
    methods: {
      onChange(index) {
        this.chosenCoupon = index;
        this.number =1;
        let data = this.coupons[index];
        if (this.role == '20') {
          this.showNumber = true;
          this.maxlength = data.max;
        } else {

          this.onExchange(data);
        }
      },
      // 领取优惠券
      onExchange(data) {
        let url = '/addons/litestore/api.coupon/receive';
        let {
          activity_id,
          coupon_id,
          number
        } = data;
        let params = {
          activity_id,
          coupon_id,
          number,
          role: this.role
        }
        //console.log(params)
        this.disabled = true;
        util.post(url, params, (res) => {
          this.$toast(res.msg);
          this.chosenCoupon = -1;
          this.showNumber = false;
          // 刷新
          this.getCardTypeList();
        });
        setTimeout(() => {
          this.disabled = false;
        }, 3000)
      },
      // 输入数量确认
      getCoupon() {
        if (this.maxlength > -1) {
          if (this.number > this.maxlength) {
            this.$toast("领取数量不能大于最大领取数量");
            return;
          }
        }
        if (this.number < 1) {
          this.$toast("领取数量不能小于1");
          return;
        }
        if (this.number > 1000) {
          this.$toast("无效领取数量");
          return;
        }
        let index = this.chosenCoupon;
        let data = this.coupons[index];
        data.number = this.number;
        this.onExchange(data);
      },
      // 获取优惠券
      getCardTypeList() {
        //http://localhost:8081/api/addons/litestore/api.coupon/index?type=20&role=20&page=1&limit=10&token=57aadea6-1caa-417e-bf11-2d5ab60d3692
        let url = "/addons/litestore/api.coupon/index";
        let param = {
          type: 20,
          role: 20,
          page: 1,
          limit: 100,
        }
        util.get(url, param, (res) => {
          this.coupons = res.data.list;
        });
      },
    }
  }
</script>
<style lang="less" scoped>
  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .block {
    width: 80%;
    padding: 15px;
    display: flex;
    align-items: center;
    flex-flow: column;
    background-color: #fff;

    h3 {
      margin-bottom: 15px;
    }

    .message {
      justify-content: flex-start;
      width: 100%;
      margin-top: 15px;
      font-size: 14px;
      color: #666;
    }

    .footer {
      margin-top: 15px;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      width: 100%;

      button {
        width: 100px;
        margin-left: 15px;
      }
    }
  }

  .coupons-btn {
    border-radius: 4px;
  }

  .nocoupons {
    background: #dfdfdf;

    .coupons-btn {
      background: #999;
      border-color: #999;
    }
  }
</style>
